module.exports = __webpack_public_path__ + "./images/logo.3a2628.svg";